const STORAGE_PREFIX = 'bookVectorization:cmsPlan:'

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null

  return window.localStorage
}

const normalizeIsbn = (isbn) => {
  return String(isbn || '').replace(/\s/g, '')
}

const getKey = (isbn) => {
  return STORAGE_PREFIX + normalizeIsbn(isbn)
}

export const getBookCmsPlan = (isbn) => {
  const storage = getStorage()
  if (!storage || !isbn) return null

  try {
    const value = storage.getItem(getKey(isbn))
    return value ? JSON.parse(value) : null
  } catch (e) {
    return null
  }
}

export const saveBookCmsPlan = (isbn, plan) => {
  const storage = getStorage()
  if (!storage || !isbn) return

  try {
    storage.setItem(
      getKey(isbn),
      JSON.stringify({
        ...(getBookCmsPlan(isbn) || {}),
        ...(plan || {}),
        isbn,
        updatedAt: new Date().toISOString(),
      }),
    )
  } catch (e) {
    // O fluxo continua sem persistencia local; o cadastro ainda usa o payload em memoria.
  }
}

export const markBookCmsPlanSynced = (isbn, summary) => {
  saveBookCmsPlan(isbn, {
    cmsStatus: summary && summary.failed > 0 ? 'partial' : 'synced',
    lastSummary: summary || null,
    syncedAt: new Date().toISOString(),
  })
}



// WEBPACK FOOTER //
// ./src/utils/bookVectorizationCmsPlan.js